<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2019-01-15 19:30:59
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-26 10:24:34
 -->
<template>
  <ul class="list_box">
    <li v-for="(item, index) in list" @click="jump(item)" :key="index">
      <div
        class="list_div vux-1px-b"
        v-if="!item.bingliImgs || item.bingliImgs.length < 2"
      >
        <img class="leftImg" :src="item.coverUrl || item.coverPic" alt="" />
        <div class="right_box">
          <p class="right_title" v-html="seachFifter(item.title)"></p>
          <div class="right_bottom">
            <img
              :src="item.sourceIcon || item.logoUrl"
              alt=""
              v-if="item.sourceIcon || item.logoUrl"
            />
            <span class="r_b_l_text">{{ item.source }}</span>
            <span v-show="ifShare == 2">
              {{ item.readCount || item.readNum || item.yueduCount || 0 }}
              {{ path == 'headlineDetail' ? '位同行阅读' : '' }}
            </span>
            <span v-show="ifShare == 1" class="readYsh">打开医生汇阅读</span>
          </div>
        </div>
      </div>
      <div class="list_div vux-1px-b" v-else>
        <div class="right_box" style="width: 100%;margin-left: 0">
          <p class="right_title">{{ item.title }}</p>
          <div class="list_imgs">
            <img v-for="itemImg in item.bingliImgs" :src="itemImg" alt="" />
          </div>

          <div class="right_bottom">
            <img
              :src="
                item.sourceIcon ||
                  'http://yxvzb.b0.upaiyun.com/images/1489719648979.png'
              "
              alt=""
            />
            <span>{{ item.source || '医生汇' }}</span>
            <span v-show="ifShare == 2">
              {{ item.readCount || item.readNum || 0 }}
              {{ path == 'headlineDetail' ? '位同行阅读' : '' }}
            </span>
            <span v-show="ifShare == 1" class="readYsh" @click="goYsh">
              打开医生汇阅读
            </span>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
/*
 * props  @list  列表数据
 *        @bottomObj 右下 内容
 *        @needHighlight 是否需要关键字高亮
 *        @keys 关键字
 *        @path 转跳类型
 *
 * */
export default {
  name: '',
  props: {
    needHighlight: {
      type: Boolean,
      default: false
    },
    keys: {
      type: String,
      default: '特殊'
    },
    path: {
      default: 'headlineDetail'
    },

    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    ifShare: {
      // 是否为分享落地页
      type: Number,
      default: 2
    }
  },
  data() {
    return {};
  },
  methods: {
    seachFifter(content) {
      if (this.needHighlight) {
        let filtercontent = content.replace(/<|>/g, '');
        return filtercontent.replace(
          new RegExp(this.keys, 'g'),
          '<span class=\'colorRed\'>' + this.keys + '</span>'
        );
      } else {
        return content;
      }
    },
    goYsh() {
      window.location =
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
    },
    jump(item) {
      // 主用于切换iframe
      this.$emit('headlineItemChange', { type: item.type, id: item.id });
      //        location.href = `${this.$config.urlPath}${this.path}/${item.id}?type=${this.type}`
      if (this.$route.query.shareFlag) {
        this.$router.push({
          name: this.path,
          params: { id: item.id },
          query: { type: item.type, shareFlag: true }
        });
      } else {
        this.$router.push({
          name: this.path,
          params: { id: item.id },
          query: { type: item.type }
        });
      }
    }
  },
  computed: {},
  components: {},
  mounted() {},
  filters: {
    heighLight: function(v) {
      return v + '<span>123</span>';
    }
  }
};
</script>
<style lang="less" scoped>
img {
  border-radius: 0.1rem;
}
.list_box {
  li:last-child {
    border: none;
  }
  .list_div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*border-bottom: 1px solid #EBEBEB;*/
    padding-bottom: 0.4rem;
    margin-top: 0.4rem;
    .leftImg {
      width: 2.96rem;
      height: 1.866rem;
    }
    .right_box {
      width: 65%;
      margin-left: 0.267rem;
      .right_title {
        font-size: 0.3733rem;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
      }
      .list_imgs {
        display: flex;
        justify-content: flex-start;
        margin-top: 0.1rem;
        img {
          width: 2.96rem;
          height: 1.9733rem;
          margin-right: 0.1rem;
        }
      }
      .right_bottom {
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 0.266rem;
        .r_b_l_text {
          width: 2.6rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        img {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
          margin-right: 0.16rem;
        }
        span {
          font-size: 0.32rem;
          color: #999;
        }
        span:nth-of-type(1) {
          width: 30%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span:nth-of-type(2) {
          position: absolute;
          right: 0;
          display: inline-block;
          // width: 2.667rem;
          /*height: .613rem;*/
          /*line-height: .613rem;*/
        }
        .readYsh {
          border: 1px solid #027cfa;
          border-radius: 3px;
          padding: 0.087rem 0.213rem;
          color: #027cfa;
        }
      }
    }
  }
}
</style>
